import { render, staticRenderFns } from "./VolumeSimpleTable.vue?vue&type=template&id=75748bc1"
import script from "./VolumeSimpleTable.vue?vue&type=script&lang=js"
export * from "./VolumeSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports